var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchPageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6302 15.6481L11.8906 10.9085C12.8087 9.77447 13.3614 8.33347 13.3614 6.76403C13.3614 3.1265 10.4017 0.166748 6.7642 0.166748C3.12669 0.166748 0.166992 3.12647 0.166992 6.764C0.166992 10.4015 3.12673 13.3613 6.76423 13.3613C8.33366 13.3613 9.77465 12.8085 10.9087 11.8904L15.6483 16.6301C15.7837 16.7655 15.9614 16.8335 16.1392 16.8335C16.317 16.8335 16.4948 16.7655 16.6302 16.6301C16.9017 16.3585 16.9017 15.9196 16.6302 15.6481ZM6.76423 11.9724C3.89199 11.9724 1.55589 9.63625 1.55589 6.764C1.55589 3.89174 3.89199 1.55563 6.76423 1.55563C9.63646 1.55563 11.9726 3.89174 11.9726 6.764C11.9726 9.63625 9.63643 11.9724 6.76423 11.9724Z",
    fill: "#4D4D4D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchPageIcon);
export default __webpack_public_path__ + "static/media/search_page_icon.b3de62e1.svg";
export { ForwardRef as ReactComponent };